import React from 'react';
import classNames from 'classnames';

const PADDING_SIZES = ['medium', 'large', 'larger'];

const CardContent = ({ children, className, padding }) => {
  const contentClassNames = classNames(
    'Card-content',
    {
      [`Card-content--${padding}Padding`]: PADDING_SIZES.includes(padding),
    },
    className,
  );

  return <div className={contentClassNames}>{children}</div>;
};

export default CardContent;
